import React, { useState, useEffect } from 'react';
import SubscriptionNavbar from '../subscription-navbar';
import ProfitSubscription from '.';
import Footer from '../../../rows/new-footer/new-footer';

import './churn-user.m.css';

const ChurnUserPage = () => {
  const [isMenu, setMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const restoreScrollAfterLazyLoad = () => {
    let lastScrollY = window.scrollY;

    const observer = new MutationObserver(() => {
      window.scrollTo(0, lastScrollY);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('scroll', () => {
      lastScrollY = window.scrollY;
    });

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', () => {
        lastScrollY = window.scrollY;
      });
    };
  };

  useEffect(restoreScrollAfterLazyLoad, []);
  const hideShowMobileMenu = (value) => {
    setMenu(value);
  };

  return (
    <div styleName="churn-user-container">
      <div className="desktop-only" styleName="nav-section">
        <SubscriptionNavbar churnUserPage={true} />
      </div>
      <div className="mobile-only" styleName={`nav-section ${isScrolled ? 'scrolled' : ''}`}>
        <SubscriptionNavbar churnUserPage={true} isMenu={isMenu} hideShowMobileMenu={hideShowMobileMenu} />
      </div>
      <ProfitSubscription churnUser={true} />
        <div styleName="footer" id="footer">
          <Footer isSubscription={true} />
        </div>
    </div>
  );
};

export default ChurnUserPage;
